import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function DogRegistrationList() {
  const [registrations, setRegistrations] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [selectedDog, setSelectedDog] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const loadRegistrations = async () => {
    try {
      setLoading(true);

      const response = await api.get("/DogRegistration/GetAll");

      const data = response.data || [];

      setRegistrations(data);
      setFilteredData(data);
    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        "Unable to load dog registrations.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRegistrations();
  }, []);

  // Search
  useEffect(() => {
    const value = search.toLowerCase().trim();

    if (!value) {
      setFilteredData(registrations);
      return;
    }

    const result = registrations.filter((item) =>
      (
        `${item.registrationNo || ""} 
        ${item.ownerName || ""} 
        ${item.mobileNo || ""} 
        ${item.dogName || ""} 
        ${item.breed || ""} 
        ${item.microchipNo || ""}`
      )
        .toLowerCase()
        .includes(value)
    );

    setFilteredData(result);
  }, [search, registrations]);

  const handleView = (item) => {
    setSelectedDog(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedDog(null);
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-GB");
  };

  return (
    <div className="container-fluid py-4">

      {/* Header */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">

          <div className="row align-items-center">

            <div className="col-md-6">
              <h3 className="mb-1">
                <i className="bi bi-heart-fill text-danger me-2"></i>
                Dog Registration
              </h3>

              <p className="text-muted mb-0">
                Registered dogs list
              </p>
            </div>

            <div className="col-md-6 text-md-end mt-3 mt-md-0">

              <button
                className="btn btn-primary"
                onClick={() =>
                  window.location.href = "/dog-registration"
                }
              >
                <i className="bi bi-plus-lg me-2"></i>
                New Registration
              </button>

            </div>

          </div>

        </div>
      </div>

      {/* Search */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">

          <div className="row">

            <div className="col-md-6">

              <label className="form-label">
                Search Registration
              </label>

              <div className="input-group">

                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Registration No / Owner / Mobile / Dog Name / Breed"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

                {search && (
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setSearch("")}
                  >
                    <i className="bi bi-x"></i>
                  </button>
                )}

              </div>

            </div>

            <div className="col-md-6 text-md-end mt-4">

              <span className="badge bg-primary fs-6">
                Total Records: {filteredData.length}
              </span>

            </div>

          </div>

        </div>
      </div>

      {/* Table */}
      <div className="card border-0 shadow-sm">

        <div className="card-body p-0">

          {loading ? (

            <div className="text-center py-5">

              <div
                className="spinner-border text-primary"
                role="status"
              ></div>

              <p className="mt-2 text-muted">
                Loading registrations...
              </p>

            </div>

          ) : filteredData.length === 0 ? (

            <div className="text-center py-5">

              <i className="bi bi-inbox fs-1 text-muted"></i>

              <h5 className="mt-3">
                No registrations found
              </h5>

              <p className="text-muted">
                No dog registration records available.
              </p>

            </div>

          ) : (

            <div className="table-responsive">

              <table className="table table-hover align-middle mb-0">

                <thead className="table-light">

                  <tr>
                    <th>#</th>
                    <th>Registration No.</th>
                    <th>Owner</th>
                    <th>Mobile</th>
                    <th>Dog Name</th>
                    <th>Breed</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Registration Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>

                </thead>

                <tbody>

                  {filteredData.map((item, index) => (

                    <tr key={item.id}>

                      <td>
                        {index + 1}
                      </td>

                      <td>
                        <strong className="text-primary">
                          {item.registrationNo || "-"}
                        </strong>
                      </td>

                      <td>
                        {item.ownerName || "-"}
                      </td>

                      <td>
                        {item.mobileNo || "-"}
                      </td>

                      <td>
                        <strong>
                          {item.dogName || "-"}
                        </strong>
                      </td>

                      <td>
                        {item.breed || "-"}
                      </td>

                      <td>

                        {item.gender === "Male" ? (
                          <span className="badge bg-info">
                            Male
                          </span>
                        ) : item.gender === "Female" ? (
                          <span className="badge bg-danger">
                            Female
                          </span>
                        ) : (
                          "-"
                        )}

                      </td>

                      <td>
                        {item.wardNo || "-"}
                      </td>

                      <td>
                        {formatDate(item.registrationDate)}
                      </td>

                      <td>

                        {item.isActive ? (
                          <span className="badge bg-success">
                            Active
                          </span>
                        ) : (
                          <span className="badge bg-secondary">
                            Inactive
                          </span>
                        )}

                      </td>

                      <td>

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          title="View"
                          onClick={() => handleView(item)}
                        >
                          <i className="bi bi-eye"></i>
                        </button>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>


      {/* Details Modal */}
      {showModal && selectedDog && (

        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >

          <div className="modal-dialog modal-xl modal-dialog-scrollable">

            <div className="modal-content">

              {/* Modal Header */}

              <div className="modal-header bg-primary text-white">

                <h5 className="modal-title">

                  <i className="bi bi-heart-fill me-2"></i>

                  Dog Registration Details

                </h5>

                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closeModal}
                ></button>

              </div>


              {/* Modal Body */}

              <div className="modal-body">

                <div className="row g-4">

                  {/* Photo */}

                  <div className="col-md-3 text-center">

                    {selectedDog.dogPhotoPath ? (

                      <img
                        src={selectedDog.dogPhotoPath}
                        alt="Dog"
                        className="img-fluid rounded border"
                        style={{
                          maxHeight: "220px",
                          objectFit: "cover"
                        }}
                      />

                    ) : (

                      <div
                        className="border rounded d-flex align-items-center justify-content-center"
                        style={{
                          height: "220px"
                        }}
                      >

                        <div>

                          <i className="bi bi-camera fs-1 text-muted"></i>

                          <p className="text-muted mb-0">
                            No photo
                          </p>

                        </div>

                      </div>

                    )}

                    <h5 className="mt-3">
                      {selectedDog.dogName}
                    </h5>

                    <span className="badge bg-primary">
                      {selectedDog.registrationNo}
                    </span>

                  </div>


                  {/* Owner Details */}

                  <div className="col-md-9">

                    <h5 className="border-bottom pb-2">
                      <i className="bi bi-person me-2"></i>
                      Owner Details
                    </h5>

                    <div className="row g-3">

                      <Detail
                        label="Owner Name"
                        value={selectedDog.ownerName}
                      />

                      <Detail
                        label="Father / Husband Name"
                        value={selectedDog.fatherHusbandName}
                      />

                      <Detail
                        label="Mobile"
                        value={selectedDog.mobileNo}
                      />

                      <Detail
                        label="Email"
                        value={selectedDog.email}
                      />

                      <Detail
                        label="Ward"
                        value={selectedDog.wardNo}
                      />

                      <Detail
                        label="Zone"
                        value={selectedDog.zone}
                      />

                      <Detail
                        label="Pincode"
                        value={selectedDog.pincode}
                      />

                      <div className="col-md-12">

                        <strong>Address</strong>

                        <p className="mb-0 text-muted">
                          {selectedDog.address || "-"}
                        </p>

                      </div>

                    </div>

                  </div>


                  {/* Dog Details */}

                  <div className="col-md-12">

                    <h5 className="border-bottom pb-2">

                      <i className="bi bi-heart me-2"></i>

                      Dog Details

                    </h5>

                    <div className="row g-3">

                      <Detail
                        label="Dog Name"
                        value={selectedDog.dogName}
                      />

                      <Detail
                        label="Breed"
                        value={selectedDog.breed}
                      />

                      <Detail
                        label="Gender"
                        value={selectedDog.gender}
                      />

                      <Detail
                        label="Date of Birth"
                        value={formatDate(selectedDog.dateOfBirth)}
                      />

                      <Detail
                        label="Age"
                        value={selectedDog.age}
                      />

                      <Detail
                        label="Color"
                        value={selectedDog.color}
                      />

                      <Detail
                        label="Microchip No."
                        value={selectedDog.microchipNo}
                      />

                      <Detail
                        label="Sterilized"
                        value={selectedDog.sterilized}
                      />

                      <Detail
                        label="Purpose"
                        value={selectedDog.purpose}
                      />

                      <div className="col-md-6">

                        <strong>
                          Identification Mark
                        </strong>

                        <p className="text-muted">
                          {selectedDog.identificationMark || "-"}
                        </p>

                      </div>

                    </div>

                  </div>


                  {/* Vaccination */}

                  <div className="col-md-12">

                    <h5 className="border-bottom pb-2">

                      <i className="bi bi-shield-check me-2"></i>

                      Vaccination Details

                    </h5>

                    <div className="row g-3">

                      <Detail
                        label="Rabies Vaccinated"
                        value={selectedDog.rabiesVaccinated}
                      />

                      <Detail
                        label="Vaccination Date"
                        value={formatDate(
                          selectedDog.vaccinationDate
                        )}
                      />

                      <Detail
                        label="Certificate No."
                        value={selectedDog.certificateNo}
                      />

                      <Detail
                        label="Next Vaccination"
                        value={formatDate(
                          selectedDog.nextVaccinationDate
                        )}
                      />

                    </div>

                  </div>


                  {/* Documents */}

                  <div className="col-md-12">

                    <h5 className="border-bottom pb-2">

                      <i className="bi bi-paperclip me-2"></i>

                      Documents

                    </h5>

                    <div className="d-flex flex-wrap gap-2">

                      {selectedDog.ownerIdProofPath && (

                        <a
                          href={selectedDog.ownerIdProofPath}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-outline-primary"
                        >
                          <i className="bi bi-file-earmark-person me-2"></i>
                          Owner ID Proof
                        </a>

                      )}

                      {selectedDog.vaccinationCertificatePath && (

                        <a
                          href={
                            selectedDog.vaccinationCertificatePath
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-outline-success"
                        >
                          <i className="bi bi-file-earmark-medical me-2"></i>
                          Vaccination Certificate
                        </a>

                      )}

                      {!selectedDog.ownerIdProofPath &&
                        !selectedDog.vaccinationCertificatePath && (
                          <span className="text-muted">
                            No documents uploaded.
                          </span>
                        )}

                    </div>

                  </div>

                </div>

              </div>


              {/* Modal Footer */}

              <div className="modal-footer">

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
}


// Reusable detail component

function Detail({ label, value }) {
  return (
    <div className="col-md-4">

      <div>
        <strong>{label}</strong>

        <div className="text-muted">
          {value || "-"}
        </div>
      </div>

    </div>
  );
}

export default DogRegistrationList;